import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';

export default function Search({
  onSearch = () => {},
  setOnlyAvailableFilter = null,
  setShowArchivedFilter = null,
  handleOnFilterCategories,
  categories,
}) {
  const [typingTimeout, setTypingTimeout] = useState(0);

  const { t } = useTranslation('search');

  const handleSearchInput = (event) => {
    const { value } = event.target;
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(setTimeout(() => {
      onSearch(value);
    }, 500));
  };

  const handleAvailableSwitch = (event) => {
    const { checked } = event.target;
    setOnlyAvailableFilter(checked);
  };

  const handleArchivedSwitch = (event) => {
    const { checked } = event.target;
    setShowArchivedFilter(checked);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Input
          variant="outlined"
          fullWidth
          onChange={handleSearchInput}
          startAdornment={(
            <InputAdornment position="start">
              <SearchSharpIcon />
            </InputAdornment>
            )}
        />
      </Grid>
      {!!categories
      && (
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="tags-outlined"
          options={categories}
          getOptionLabel={(option) => option.name}
          filterSelectedOptions
          onChange={handleOnFilterCategories}

          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={t('category_placeholder')}
              label={t('categories')}
            />
          )}
        />
      </Grid>
      )}
      {/* Les deux commutateurs partagent une ligne : ce sont deux façons de
          restreindre la MÊME liste, et les empiler laissait croire à deux
          réglages sans rapport. `flexWrap` les remet l'un sous l'autre quand
          l'écran est trop étroit — jamais de débordement horizontal. */}
      { (setOnlyAvailableFilter || setShowArchivedFilter)
      && (
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 3 }}>
          { setOnlyAvailableFilter && (
          <FormControlLabel
            control={(
              <Switch
                onChange={handleAvailableSwitch}
              />
          )}
            label={t('availableSwitch')}
          />
          )}
          {/* Réservé aux écrans de la bibliothèque : la vitrine publique ne
              reçoit pas cette prop, et ne doit jamais montrer d'archivé. */}
          { setShowArchivedFilter && (
          <FormControlLabel
            control={(
              <Switch
                onChange={handleArchivedSwitch}
              />
          )}
            label={t('archivedSwitch')}
          />
          )}
        </Box>
      </Grid>
      )}
    </Grid>
  );
}

Search.propTypes = {
  onSearch: PropTypes.func,
  setOnlyAvailableFilter: PropTypes.func,
  setShowArchivedFilter: PropTypes.func,
};
